import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import EvaluateAbilitiesOtherIssues from './EvaluateAbilitiesOtherIssues';
import { SUBTABS, OTHER_STEPS } from './ConstPaths';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  otherIssues: PropTypes.string, 
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  otherIssues: '',
};

//Manage the wizard form for the Evaluate Abilities / Physical sub-tab
//Initialize the forms with props and manage those as local state.
//On Continue, update the global Session state with the local state from the forms. 
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/

const BASE_URL = SUBTABS.OTHER + "/";
//the steps of the wizard form:
const steps = OTHER_STEPS;

const NEXT_SECTION = SUBTABS.EVAL_REVIEW;

class EvaluateAbilitiesOther extends React.Component {
  constructor(props) {
    super(props);
    //manage the incoming values as local state
    this.state = {
      otherIssues: this.props.otherIssues
    };

    this.saveOtherIssues = this.saveOtherIssues.bind(this);
    this.onContinue = this.onContinue.bind(this);
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/gather-info/goals/intro' would have step of 'intro'
    const stepParam = this.props.match.params.step;
    if(stepParam){
      console.log("EvalAbilOther.getCurrentStep: got step from URL");
      return(stepParam);
    }
    else{
      console.log("EvalAbilOther.getCurrentStep: using default step");
      return(steps.INTRO);
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  //For Cognition section, we only have one step, but doing it this way
  //is parallel to all the other sections, and allows us to easily add steps.
  onContinue() {
    let history = this.props.history;
    let location = this.props.location;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    const curURL = new URL(window.location.href);

    switch(this.getCurrentStep()){
      case steps.CHARACTERISTICS:
        nextStep = '';
        goToNextSection = true;
        break;
      default:
        console.log("   default next step");
        nextStep = steps.CHARACTERISTICS;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      // alert("Done with this section. Data saved are: " + JSON.stringify(this.state));
      nextRoute = NEXT_SECTION;
    }
    console.log("    pushing new route: " + nextRoute);
    history.push({
      pathname: nextRoute,
      search: curURL.search
    });
  }

  saveOtherIssues(){
    this.props.updateSession('otherIssues', this.state.otherIssues);
  }
  //called from the child form when the user changes anything
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;
      // console.log("Updating EvaluateAbilitiesOther state with key: " + key + " value: " + value);
      this.setState({ [key]: value });
    }
  }

  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  componentDidUpdate(prevProps, prevState){
    //for simple strings
    if (this.props.otherIssues !== prevProps.otherIssues){
        console.log("--incoming props: " + this.props.otherIssues + " differ from prev props: " + prevProps.otherIssues);
        this.setState({'otherIssues': this.props.otherIssues});
    }
  }

  render() {
    console.log("EvaluateAbilitiesOther.render()");
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const curURL = new URL(window.location.href);
    const searchQuery = curURL.search;
    
    return(
    <>
    <Switch>
      <Route path={BASE_URL + steps.CHARACTERISTICS}>
        <EvaluateAbilitiesOtherIssues
            key={steps.CHARACTERISTICS}
            firstName={firstName}
            pronouns={pronouns}
            otherIssues={this.state.otherIssues}
            onChangeOtherIssues={this.updateLocalState("otherIssues")}
            saveFormData={this.saveOtherIssues}
            onContinue={this.onContinue}
          />
      </Route>
      <Route path={BASE_URL}>
        <Redirect to={BASE_URL + steps.CHARACTERISTICS + searchQuery} />
      </Route>
    </Switch>
    </>
    );
  }
}

EvaluateAbilitiesOther.propTypes = propTypes;
EvaluateAbilitiesOther.defaultProps = defaultProps;


// withRouter wrapper provides access to the match, location, and history props
// "You can get access to the history object’s properties and the closest <Route>'s match 
// via the withRouter higher-order component. withRouter will pass updated 
// match, location, and history props to the wrapped component whenever it renders"
export default withRouter(EvaluateAbilitiesOther);
